import axios from 'src/utils/request'
export const androidNetwork = {
    list: (...args: any[]) => 
        axios.post('/sdkAndroid/getAdNetworkList', ...args),

    add: (...args: any[]) => 
        axios.post('/sdkAndroid/addAdNetwork', ...args),

    update: (...args: any[]) => 
        axios.post('/sdkAndroid/updateAdNetwork', ...args),

    delete: (...args: any[]) => 
        axios.post('/sdkAndroid/deleteAdNetwork', ...args),

    

}

export const iosNetwork = {
    list: (...args: any[]) => 
        axios.post('/sdkIos/getAdNetworkList', ...args),

    add: (...args: any[]) => 
        axios.post('/sdkIos/addAdNetwork', ...args),

    update: (...args: any[]) => 
        axios.post('/sdkIos/updateAdNetwork', ...args),

    delete: (...args: any[]) => 
        axios.post('/sdkIos/deleteAdNetwork', ...args),

    

}